import { mkChartOfAccount } from 'data/chartOfAccounts/types';
import { mkSplitItem } from './types';

export function sumSplitRows(items) {

  let sum = 0;
  items.forEach((x) => {
    sum += Number(x.amount);
  });
  return Number(sum.toFixed(2));
}

export const splitTxnRemainder = (txn) =>
  Number((Number(txn.amount) - sumSplitRows(txn.split.items)).toFixed(2));


export function addRemainderToSplit(txn, remainder) {

  const itemIndex = txn.split.items.findIndex((item) =>
    ((item.coa && item.coa.type === 'UNCATEGORIZED') && Number(item.coa.id) === 0));

  if (itemIndex !== -1) {
    let item = txn.split.items.get(itemIndex);
    item = item.set('amount', Number(item.amount) + remainder);
    const newItems = txn.split.items.set(itemIndex, item);
    return txn.setIn(['split', 'items'], newItems);
  }
  // need to create the uncategorized row
  const newItem = mkSplitItem(
    {
      amount: remainder,
      coa: mkChartOfAccount({ id: 0, type: 'UNCATEGORIZED' }),
    }
  );
  const newTxn = txn.setIn(['split', 'items'], txn.split.items.push(newItem));

  return newTxn;
}
